































import Vue from "vue";
import _ from "lodash";
import AdvertisementForm from "@/components/Form/AdvertisementForm.vue";
import { Advertisement } from "@/interfaces/advertisement";
import { Advertiser } from "@/interfaces/advertiser";
import { HeaderProcess } from "@/plugins/HeaderProcess";
export default Vue.extend({
  components: { AdvertisementForm },
  async mounted() {
    if (this.$route.query.from) {
      const from = await this.$store.dispatch("get", [
        "/api/adv/posts/" + this.$route.query.from
      ]);
      for (const i of [1, 2, 3, 4, 5]) {
        if (from["image" + i]) {
          from["image" + i] = await this.$store.dispatch("get", [
            from["image" + i]["@id"]
          ]);
        }
      }
      delete from["@id"];
      delete from.id;
      delete from.publicAdvertisement;
      delete from.publishmentOrder;
      // this.$set(this, "advertisement", from);
      _.merge(this.advertisement, from);
      for (const i of [1, 2, 3, 4, 5]) {
        const k = ("image" + i) as
          | "image1"
          | "image2"
          | "image3"
          | "image4"
          | "image5";
        if (
          this.advertisement.eyeCatch &&
          this.advertisement[k] &&
          (this.advertisement.eyeCatch as any)["@id"] ==
            (this.advertisement[k] as any)["@id"]
        ) {
          this.advertisement.eyecatchIndex = i;
        }
      }

      this.$forceUpdate();
    } else {
      const advertiser: Advertiser = await this.$store.dispatch("get", [
        this.$store.getters.my().advertiser
      ]);
      if (advertiser) {
        this.$set(this.advertisement, "storeName", advertiser.companyName);
        this.$set(
          this.advertisement,
          "storeAddress",
          (advertiser.prefecture || "") +
            (advertiser.city || "") +
            (advertiser.address || "")
        );
      }
    }
    this.isLoading = false;
  },
  data() {
    return {
      advertisement: {
        mapParameters: ""
      } as Partial<Advertisement>,
      errors: {},
      isLoading: true,
      phase: "input"
    };
  },
  methods: {
    async confirm() {
      this.errors = {};
      this.isLoading = true;
      const postData: Record<string, any> = {};
      for (const [k, v] of Object.entries(this.advertisement)) {
        if (_.isPlainObject(v) && (v as any)["@id"]) {
          postData[k] = (v as any)["@id"];
        } else {
          postData[k] = v;
        }
      }

      try {
        const decorated = await this.decoratePostData(postData);
        await this.$store.dispatch("post", [
          "/api/adv/posts/validate",
          decorated
        ]);
        this.phase = "confirm";
      } catch (violations) {
        for (const v of violations as {
          propertyPath: string;
          message: string;
        }[]) {
          this.$set(this.errors, v.propertyPath, v.message);
        }
        (
          document.getElementsByClassName("main")[0] || document.body
        ).scrollIntoView({
          behavior: "auto",
          block: "start"
        });
      }
      this.isLoading = false;
    },
    async exec() {
      this.errors = {};
      this.isLoading = true;
      const postData: { [key: string]: unknown } = {};
      for (const [k, v] of Object.entries(this.advertisement)) {
        if (_.isPlainObject(v) && (v as any)["@id"]) {
          postData[k] = (v as any)["@id"];
        } else {
          postData[k] = v;
        }
      }
      const decorated = await this.decoratePostData(postData);

      try {
        const ret = await this.$store.dispatch("post", [
          "/api/adv/posts",
          decorated
        ]);
        this.phase = "confirm";
        this.$router.push({
          name: "AdvertiserAdvertisementsPublishment",
          params: { id: ret.id }
        });
      } catch (ex) {
        alert("登録時にエラーが発生しました");
      }
      this.isLoading = false;
    },
    async decoratePostData(this: any, postData: Record<string, unknown>) {
      const fileViolations = [];
      for (const [key, file] of Object.entries(this.$refs.form.files)) {
        if (file) {
          try {
            const ret = await this.$store.dispatch("uploadFile", file);
            postData[key] = ret["@id"];
            this.$set(this.advertisement, key, ret);
          } catch (violations) {
            console.error(violations);
            // this.$delete(this.advertisement, key);
            for (const v of violations as {
              propertyPath: string;
              message: string;
            }[]) {
              fileViolations.push({ propertyPath: key, message: v.message });
            }
          }
          this.$refs.form.files[key] = undefined;
        }
      }
      if (fileViolations.length) {
        throw fileViolations;
      }
      postData["eyeCatch"] = postData["image" + postData["eyecatchIndex"]];
      postData["owner"] = this.$store.getters.my().advertiser;

      delete postData.publicAdvertisement;
      delete postData.publishmentOrder;

      return postData;
    }
  },
  computed: {
    _() {
      return _;
    },
    headerProcess() {
      const hp = new HeaderProcess();
      hp.processes.push({ idx: 1, title: "広告新規作成" });
      hp.processes.push({ idx: 2, title: "広告新規作成確認画面" });
      hp.processes.push({ idx: 3, title: "広告掲載申し込み" });
      hp.processes.push({ idx: 4, title: "広告掲載申し込み確認画面" });
      hp.processes.push({ idx: 5, title: "広告掲載申し込み完了" });

      hp.activeIdx = this.phase == "input" ? 1 : 2;

      return hp;
    },
    isPage() {
      return true;
    }
  }
});
